/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import {Button} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import IconWithLabel from "../../widgets/IconWithLabel/IconWithLabel";
import PropTypes from "prop-types";
import validator from "validator";
import { PERMISSIONS } from "../../../constants/APP_CONSTANTS";

export default class SaleRepSearch extends React.Component {

    static propTypes = {
        search: PropTypes.func.isRequired,
        clearFields: PropTypes.func.isRequired,
        isPending:PropTypes.bool,
        permissions:PropTypes.func.isRequired,
        isLoading:PropTypes.bool
    };

    state = {
        isbn: "",
        instructor: "",
        title: "",
        school: ""
    };

    clearAll = () => {
        this.setState({
            isbn: "",
            instructor: "",
            title: "",
            school: ""
        });
        this.props.clearFields({
            isbn: "",
            instructor: "",
            title: "",
            school: ""
        });
        this.props.search({
            isbn: "",
            instructor: "",
            title: "",
            school: ""
        });
    };

    disableSearchButton = () => {
        let {isbn,instructor,title,school} = this.state;
        return !validator.isEmpty(isbn) || !validator.isEmpty(instructor) || !validator.isEmpty(title) || !validator.isEmpty(school);
    };

    searchCollections = () => {
        if (!this.validate()) {
            return false;
        }
        this.props.search({
            isbn: this.state.isbn.trim(),
            instructor: this.state.instructor.trim(),
            title: this.state.title.trim(),
            school: this.state.school.trim()
        });

    };
    validate = () => {
        const {isbn, instructor, title, school} = this.state;
        if (!this.isEmpty(isbn) || !this.isEmpty(instructor) || !this.isEmpty(title) || !this.isEmpty(school)) {
            return true;
        }
    };

    isEmpty = (str) => {
        return (!str || 0 === str.length);
    };

    render() {
        let disableSearch = this.disableSearchButton();
        const loading = this.props.isLoading;      
        return (
            <div>
                <div className="search-component">
                    <div className="search-header">
                        <label className="pe-page-title--small">
                        Search & View My Collections
                        </label>
                        <IconWithLabel
                            icon="remove-sm-24"
                            label="Clear All"
                            onClick={this.clearAll}
                        />
                    </div>
                    <hr/>
                    <div className="search-fields">
                        <div className="search-input-field">
                            <input
                                type="text"
                                className="pe-textInput--basic input-field"
                                value={this.state.isbn}
                                readOnly = {loading}
                                onChange={e => {
                                    this.setState({isbn: e.target.value});
                                }}
                                placeholder={"ISBN"}
                                onKeyDown={e => {
                                    if (e.key === "Enter") {
                                        this.searchCollections();
                                    }
                                }}
                               
                            /></div>
                        <div className="search-input-field">
                            <input
                                type="text"
                                className="pe-textInput--basic input-field"
                                value={this.state.instructor}
                                readOnly = {loading}
                                onChange={e => {
                                    this.setState({instructor: e.target.value});
                                }}
                                placeholder={"Instructor's Name"}
                                onKeyDown={e => {
                                    if (e.key === "Enter") {
                                        this.searchCollections();
                                    }
                                }}
                              
                            /></div>
                        <div className="search-input-field">
                            <input
                                type="text"
                                className="pe-textInput--basic input-field"
                                value={this.state.title}
                                readOnly = {loading}
                                onChange={e => {
                                    this.setState({title: e.target.value});
                                }}
                                placeholder={"Book Title"}
                                onKeyDown={e => {
                                    if (e.key === "Enter") {
                                        this.searchCollections();
                                    }
                                }}
                             
                            /></div>
                        <div className="search-input-field">
                            <input
                                type="text"
                                className="pe-textInput--basic input-field"
                                value={this.state.school}
                                readOnly = {loading}
                                onChange={e => {
                                    this.setState({school: e.target.value});
                                }}
                                placeholder={"School"}
                                onKeyDown={e => {
                                    if (e.key === "Enter") {
                                        this.searchCollections();
                                    }
                                }}
         
                            />
                        </div>
                        <div className="search-button">
                            {!disableSearch ? <Button disabled btnType="primary">Search</Button> : <Button btnType="primary" onClick={this.searchCollections}>Search</Button>   }
                        </div>
                    </div>
                </div> 
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/SaleRepCapabilities/saleRepSearch.js